import React from 'react'

const HelpCircleIcon = () => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_2997_4242)">
        <path
          d="M7.00002 12.8333C10.2217 12.8333 12.8334 10.2216 12.8334 6.99996C12.8334 3.7783 10.2217 1.16663 7.00002 1.16663C3.77836 1.16663 1.16669 3.7783 1.16669 6.99996C1.16669 10.2216 3.77836 12.8333 7.00002 12.8333Z"
          stroke="#757575"
          strokeWidth="1.16667"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.30249 5.24997C5.43963 4.86011 5.71033 4.53136 6.06663 4.32196C6.42293 4.11256 6.84185 4.03601 7.24918 4.10588C7.65651 4.17575 8.02597 4.38752 8.29212 4.70369C8.55827 5.01986 8.70394 5.42002 8.70332 5.8333C8.70332 6.99997 6.95332 7.5833 6.95332 7.5833"
          stroke="#757575"
          strokeWidth="1.16667"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7 9.91663H7.00583"
          stroke="#757575"
          strokeWidth="1.16667"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_2997_4242">
          <rect width="14" height="14" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default HelpCircleIcon
